<template>
    <top />
    <div class="content" v-loading.fullscreen.lock="loading">
        <el-form :model="model">
            <el-table size="mini"
                      :data="profileList"
                      border
                      element-loading-text="加载中"
                      style="width: 100%">
                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column label="id" prop="id" width="250"> </el-table-column>
                <el-table-column label="name" prop="name">
                    <template #default="scope">
                        <el-form-item>
                            <el-input v-if="inputShow == scope.row.id"
                                      v-model="model.editList[scope.$index].name"
                                      size="small"></el-input>
                            <span class="ellipsis" v-else>
                                {{model.editList[scope.$index].name}}
                            </span>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="描述" prop="description">
                    <template #default="scope">
                        <el-form-item>
                            <el-input v-if="inputShow == scope.row.id"
                                      v-model="model.editList[scope.$index].description"
                                      size="small"></el-input>
                            <span class="ellipsis" v-else>
                                {{model.editList[scope.$index].description}}
                            </span>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="配置内容" prop="body">
                    <template #default="scope">
                        <el-form-item>
                            <span class="ellipsis"
                                  style="color: #66c2ff; cursor: pointer"
                                  v-if="inputShow == scope.row.id"
                                  size="small"
                                  @click="doExpr(scope.row, scope.$index)">{{ model.editList[scope.$index].body }}</span>
                            <span class="ellipsis" v-else>
                                {{model.editList[scope.$index].body}}
                            </span>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="230">
                    <template #default="scope">
                        <el-button @click="change(scope.row)"
                                   v-if="inputShow !== scope.row.id"
                                   type="primary"
                                   size="mini">修改</el-button>
                        <el-button @click="save(scope.row.id)"
                                   v-else
                                   type="primary"
                                   size="mini">保存</el-button>
                        <el-popconfirm title="确定删除吗？"
                                       confirmButtonText="确定"
                                       cancelButtonText="取消"
                                       @confirm="del(scope.row.id)">
                            <template #reference>
                                <el-button type="danger" size="mini">删除</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <el-button icon="el-icon-plus"
                   @click="append"
                   class="marginBottom"
                   size="small">添加</el-button>
        <div v-show="containerShow" class="mask">
            <div class="mask-c">
                <div ref="container" class="container"></div>
                <div class="footer">
                    <el-button type="primary" @click="saveExpr">保存</el-button>
                    <el-button @click="exprBack">返回</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import top from "../../components/top.vue";
    import { TableProfileEdit, TableProfileDelete, TableProfile } from "../../api/support";
    import * as monaco from "monaco-editor";
    export default {
        components: { top },
        data() {
            return {
                loading: false,
                test: {
                    name: "ddd",
                    description: "eee",
                    body: "fff",
                },
                profileList: [],
                model: {
                    editList: [], //编辑状态下表格主体
                },
                inputShow: false,
                containerShow: false,
                bodyId: ''
            };
        },
        created() {
            this.init();
        },
        mounted() {
            this.initEditor();
        },
        methods: {
            doExpr(row, index) {
                this.containerShow = true;
                this.bodyId = row.id;
                if (this.model.editList[index].body == "点击输入") {
                    this.editor.setValue("");
                } else {
                    this.editor.setValue(this.model.editList[index].body);
                }
            },
            exprBack() {
                this.containerShow = false;
                this.editor.setValue("");
            },
            saveExpr() {
                let ac = this.editor.getValue();
                this.model.editList.forEach((ele) => {
                    if (ele.id == this.bodyId) {
                        ele.body = ac;
                    }
                });
                this.containerShow = false;
            },
            initEditor() {
                this.editor = monaco.editor.create(this.$refs.container, {
                    value: "", //编辑器初始显示文字
                    language: "javascript", //语言支持自行查阅demo
                    selectOnLineNumbers: true, //显示行号
                    glyphMargin: true, //字形边缘
                    // autoIndent: true, //自动布局
                    automaticLayout: true, //自动布局
                    theme: "vs-dark", //官方自带三种主题vs, hc-black, or vs-dark
                });
            },
            append() {
                this.inputShow = "";
                this.profileList.push({
                    id: "",
                    name: "",
                    description: "",
                    body: "点击输入",
                });
                this.model.editList.push({
                    id: "",
                    name: "",
                    description: "",
                    body: "点击输入",
                });
            },
            save(id) {
                let a = this.model.editList.find((e) => e.id == id);
                if (a.id == '') {
                    delete a.id
                }
                TableProfileEdit(a)
                    .then((res) => {
                        if (res.status == 0) {
                            this.$message.success("已保存");
                            this.init();
                        }
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
                this.inputShow = false;
            },
            change(row) {
                this.inputShow = row.id;
            },
            del(id) {
                if (id == "") {
                    this.init();
                    this.inputShow = false;
                    return;
                }
                this.loading = true;
                TableProfileDelete({
                    id: id,
                })
                    .then((res) => {
                        if (res.status == 0) {
                            this.$message.success("已删除");
                            this.init();
                        }
                    });
            },
            init() {
                this.loading = true;
                TableProfile()
                    .then((res) => {
                        this.profileList = res.profiles;
                        this.model.editList = res.profiles.map((e) => {
                            return {
                                id: e.id,
                                body: e.body,
                                description: e.description,
                                name: e.name,
                            };
                        });
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },
            add() {
                this.loading = true;
                TableProfileEdit(this.test).then((res) => {
                    if (res.status == 0) {
                        this.$message.success("添加成功");
                    }
                    this.loading = false;
                });
            },
        },
    };
</script>

<style scoped>
    .content {
        width: 90%;
        margin: 0 auto;
        margin-top: 50px
    }

    .el-form-item {
        margin-bottom: 0px;
    }

    .content .mask {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1;
    }

        .content .mask .mask-c {
            width: 70%;
            background-color: #fff;
            margin: 0 auto;
            margin-top: 1%;
            overflow: hidden;
        }

            .content .mask .mask-c .container {
                height: 85vh;
                width: 90%;
                background-color: #000000;
                margin: 0 auto;
                margin-top: 2%;
            }

    .footer {
        float: right;
        margin: 2% 50px 10px 0;
    }

    .ellipsis {
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
    }
</style>